import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { ROUTE_PATH,APPLICATION_MODE_NEW } from "../../../app/constants";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";

export const ResidencyConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const [showConfirmationError, setShowConfirmationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  
  const handleNext = (isResidentOfCanada) => () => {
    setShowConfirmationError(!isResidentOfCanada);

    if(isResidentOfCanada) {
        dispatch(
            push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_AGE_CONFIRMATION}`)
        );
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>Are you a resident of Canada?</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showConfirmationError &&
            ErrorWithString(`The ${isPrincipalBroker ? 'Principal Broker' : 'Compliance Officer'} must be a resident of Canada.`)
          }
        </div>
      </div>
    </div>
  );
};
